import { Component, Input,Output, OnChanges, OnInit, EventEmitter } from '@angular/core';
import { ControlContainer, FormBuilder, FormGroup, Validators } from '@angular/forms';
@Component({
  selector: 'app-expense-approval-details',
  templateUrl: './expense-approval-details.component.html',
  styleUrls: ['./expense-approval-details.component.css']
})
export class ExpenseApprovalDetailsComponent implements OnInit {
  @Input() expenseFormGroup: FormGroup;
  @Input() displayControl;
  isSumApprovedInValid: boolean;
  totalInvoicedAmt;
  isTravelUser: any = false;
  dropdownSettings = {};
  // showMsg;


  constructor(
    private controlContainer: ControlContainer
  ) { this.checkViewPermission() }

  checkViewPermission(){
    if(JSON.parse(localStorage.currentUser).roleValue == '5672') {
      this.isTravelUser = false
    }
    if(JSON.parse(localStorage.currentUser).roleValue == '3421') {
      this.isTravelUser = true
    }
    if(JSON.parse(localStorage.currentUser).roleValue == '9918' || '2898') {
      this.isTravelUser = true
    }
  }


  ngOnInit(){
    const selBill = JSON.parse(sessionStorage.getItem('selectedBill'));
    // console.log('selBillApr ', selBill.approvalDetails && selBill.approvalDetails.sumApproved.length)
    if(selBill && selBill.approvalDetails && selBill.approvalDetails.sumApproved.length == 0){
      this.isTravelUser = false
    }
    this.expenseFormGroup = <FormGroup>this.controlContainer.control;
    // console.log('approvedDate: ', this.expenseFormGroup.value.approvalDetails.approvedDte, new Date(this.expenseFormGroup.value.approvalDetails.approvedDte))
    console.log(this.expenseFormGroup);

    setTimeout(() => {
      this.totalInvoicedAmt = this.expenseFormGroup.value.paymentDetails.totalInvoicedAmount;
      // const { approvalStatus } = this.expenseFormGroup.value.approvalDetails;

      // this.showMsg = approvalStatus === 'pending';
    }, 2000);

    console.log('showMsg:', this.totalInvoicedAmt)
    this.expenseFormGroup.get('approvalDetails').valueChanges.subscribe(selectedValue  => {
      const { sumApproved } = selectedValue;
      this.isSumApprovedInValid = +sumApproved < 1 || +sumApproved > +this.totalInvoicedAmt ? true : false;
      if(this.isSumApprovedInValid) {
        this.expenseFormGroup.invalid;
      } else {
        this.expenseFormGroup.valid;
      }
    })

  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }


  selectApprovedDate(event) {
    console.log(event);
    let year = event.year;
    let month = event.month <= 9 ? "0" + event.month : event.month;
    let day = event.day <= 9 ? "0" + event.day : event.day;
    let finalDate = day + "-" + month + "-" + year;
    this.expenseFormGroup.patchValue({
      endDate: finalDate,
    });
    console.log(finalDate, this.expenseFormGroup.value);
    this["endDate"] = finalDate;
  }

}
